interface SlidersIconProps {
  className?: string;
  filled?: boolean;
}

export function SlidersIcon({ className, filled }: SlidersIconProps) {
  if (filled) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        className={className}
      >
        <line x1="4" y1="21" x2="4" y2="3" />
        <line x1="12" y1="21" x2="12" y2="3" />
        <line x1="20" y1="21" x2="20" y2="3" />
        <circle cx="4" cy="14" r="3" fill="currentColor" stroke="none" />
        <circle cx="12" cy="8" r="3" fill="currentColor" stroke="none" />
        <circle cx="20" cy="16" r="3" fill="currentColor" stroke="none" />
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <line x1="4" y1="21" x2="4" y2="14" />
      <line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" />
      <line x1="20" y1="12" x2="20" y2="3" />
      <line x1="1" y1="14" x2="7" y2="14" />
      <line x1="9" y1="8" x2="15" y2="8" />
      <line x1="17" y1="16" x2="23" y2="16" />
    </svg>
  );
}
